<template>
  <v-card
    :loading="loading"
    class="my-4"
  >
    <v-card-title>
      <v-row>
        <v-col class="my-auto"> 4Over Products </v-col>
        <v-spacer />
        <v-col cols="auto">
          <v-btn
            color="success"
            @click="showFilter"
          >
            <v-icon>filter_list</v-icon>
            Filter
          </v-btn>
        </v-col>
        <v-col
          v-if="selected.length"
          cols="auto"
        >
          <v-btn
            class="full-height"
            :loading="saving"
            @click="showAddDrawer"
          >
            Add/Update ({{ selected.length }})
          </v-btn>
        </v-col>
        <v-col
          v-if="selected.length"
          cols="auto"
        >
          <v-btn
            color="error"
            :loading="saving"
            @click="ignore"
          >
            Ignore ({{ selected.length }})
          </v-btn>
        </v-col>
        <v-col cols="auto">
          <v-select
            v-model="masterAccountId"
            :items="fourover_master_accounts"
            outlined
            dense
            label="Sync Master Account"
            item-text="name"
            item-value="id"
            hide-details
          >
            <template #append-outer>
              <v-btn @click="refresh">
                <v-icon>refresh</v-icon>
                Sync Existing
              </v-btn>
            </template>
          </v-select>
        </v-col>
      </v-row>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <v-data-table
        v-model="selected"
        :items="itemsToShow"
        :headers="headers"
        show-select
        item-key="externalId"
        :items-per-page="1000"
        mobile-breakpoint="0"
      >
        <template #[`item.relatedPrintProductId`]="{ item }">
          <v-btn
            v-if="item.relatedPrintProductId"
            :to="`/print/products/${item.relatedPrintProductId}`"
            color="info"
            text
          >
            view
          </v-btn>
        </template>
        <template #[`item.missingData`]="{ item }">
          <v-icon
            v-if="item.missingData"
            color="success"
          >
            check
          </v-icon>
        </template>
        <template #[`item.actions`]="{ item }">
          <v-menu
            v-if="!item.relatedPrintProductId"
            absolute
          >
            <template #activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                icon
                v-on="on"
                @click.prevent
              >
                <v-icon>more_vert</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="add(item.externalId)">
                <v-list-item-title>Add</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card-text>
    <PrintFourOverFilter />
    <PrintFourOverAdd @save="loadData" />
  </v-card>
</template>

<script>
import PrintFourOverAdd from '@/components/print/fourover/Add';
import PrintFourOverFilter from '@/components/print/fourover/Filter';
import { orderBy } from 'lodash';
import { mapGetters } from 'vuex';
export default {
  name: 'PrintFourOverList',
  components: { PrintFourOverFilter, PrintFourOverAdd },
  data() {
    return {
      loading: false,
      saving: false,
      selected: [],
      masterAccountId: null
    };
  },

  computed: {
    headers() {
      return [
        { text: 'Id', value: 'externalId' },
        { text: 'Code', value: 'code' },
        { text: 'Description', value: 'description' },
        { text: 'Category', value: 'category' },
        { text: 'In System?', value: 'relatedPrintProductId' },
        { text: 'Missing Data?', value: 'missingData' },
        { text: '', value: 'actions', sortable: false }
      ];
    },

    itemsToShow() {
      let list = this.list;
      if (this.filter) {
        if (this.filter.categoryId) {
          list = list.filter(
            (x) => x.categories.filter((x) => x.id === this.filter.categoryId).length
          );
        }
        if (this.filter.inSystem) {
          list = list.filter((x) => x.relatedPrintProductId != null);
        } else if (this.filter.inSystem === false) {
          list = list.filter((x) => x.relatedPrintProductId == null);
        }
        if (this.filter.missingData) {
          list = list.filter((x) => x.missingData);
        } else if (this.filter.missingData === false) {
          list = list.filter((x) => !x.missingData);
        }
        if (this.filter.search) {
          const search = this.filter.search.toLowerCase();
          list = list.filter(
            (x) =>
              x.code.toLowerCase().includes(search) ||
              x.description.toLowerCase().includes(search) ||
              // x.category.toLowerCase().includes(search) ||
              x.categories.filter((y) => y.name.toLowerCase().includes(search)).length
          );
        }
      }
      return orderBy(list, ['description'], ['asc']);
    },
    ...mapGetters({
      list: 'print/fourover_list',
      filter: 'print/fourover_filter',
      fourover_master_accounts: 'print/fourover_master_accounts'
    })
  },

  async mounted() {
    this.loadData(true);
  },

  methods: {
    loadData(initial) {
      this.selected = [];
      this.loading = true;
      const calls = [
        this.$store.dispatch('print/getFourOverProducts'),
        this.$store.dispatch('print/getFourOverMasterAccounts'),
        this.$store.dispatch('lookup/getCategories')
      ];
      if (initial) {
        calls.push(this.$store.dispatch('print/setFourOverFilter', { inSystem: false }));
      }
      Promise.all(calls)
        .then(() => {
          this.masterAccountId = this.fourover_master_accounts.map((x) => x.id)[0];
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    add(externalId) {
      this.saving = true;
      this.$store
        .dispatch('print/addFourOverProduct', externalId)
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    },
    showAddDrawer() {
      this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.ADD_4OVER_PRODUCTS_SHOW, {
        externalIds: this.selected.map((x) => x.externalId)
      });
    },
    refresh() {
      this.$store.dispatch('print/refreshFourOverProducts', this.masterAccountId);
      this.$root.$snackbarSuccess('Refresh has started. This will take a while to complete');
    },
    showFilter() {
      this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.FILTER_4OVER_SHOW);
    },
    ignore() {
      this.saving = true;
      this.$store
        .dispatch(
          'print/ignoreFourOverProducts',
          this.selected.map((x) => x.id)
        )
        .then(() => {
          this.selected = [];
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.v-select ::v-deep .v-input__append-outer {
  margin-top: auto !important;
  margin-bottom: auto !important;
}
</style>
